import { REGEX_CONDITION } from '../../../constants';

/**
 * Checks if a placeholder is present in the given link.
 *
 * @param {string} link - The link to be checked for a placeholder.
 * @returns {boolean} - Returns true if the placeholder is present, otherwise false.
 */
export function isPlaceholderPresent(link: string) {
  const conditions = new RegExp(REGEX_CONDITION.PLACEHOLDER);

  return conditions.test(link);
}
